import React, { useState } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { NotificationManager } from "react-notifications";
import * as API from "../api/index";
import { useDataView } from "../../contexts/data.view.context";
import { FormField, FormSelectField, FormActions } from "../util/formFields";

const ViewEditConnection = ({
  curRow,
  handleDetailClose,
  editable,
  onEditClick,
  data,
}) => {
  const { fetchEIConenctionsFromAllEnv } = useDataView();
  const values = curRow.original;

  let conDataFieldRows = calculateCmdTextLines(values);

  const [formData, setFormData] = useState({
    _CONNECTION_ID: values._CONNECTION_ID,
    CONNECTION_ID: values.CONNECTION_ID,
    CONNECTION_TYPE: values.CONNECTION_TYPE,
    PROJECT_ID: values.PROJECT_ID,
    PROJECT_OID: values.PROJECT_OID,
    PROJECT_NAME: values.PROJECT_NAME,
    SPONSOR_NAME: values.SPONSOR_NAME,
    BUSINESS_ID: values.BUSINESS_ID,
    CONNECTION_URL: values.CONNECTION_URL,
    CONNECTION_PROVIDER: values.CONNECTION_PROVIDER,
    CONNECTION_DATA: values.CONNECTION_DATA,
    AUTH_TYPE: values.AUTH_TYPE,
    AUTH_ID: values.AUTH_ID,
    AUTH_PIN: values.AUTH_PIN,
    AUTH_PASSCODE: values.AUTH_PASSCODE,
    STATE: values.STATE,
    MAX_ROWS_PER_QUERY:
      values.MAX_ROWS_PER_QUERY === null ? "" : values.MAX_ROWS_PER_QUERY,
    // Was MAX_QUEERIES (typo) — never matched the real MAX_QUERIES column,
    // so this field always initialized blank and never actually saved.
    MAX_QUERIES: values.MAX_QUERIES === null ? "" : values.MAX_QUERIES,
    PING_SERVICE: values.PING_SERVICE === null ? "" : values.PING_SERVICE,
    COMMENTS: values.COMMENTS === null ? "" : values.COMMENTS,
  });

  const items = ["Active", "Not Active", "Closed", "Pending", "Locked"];

  function handleSubmit(event) {
    event.preventDefault();
    const CONNECTION_ID = formData.CONNECTION_ID;
    const org_con_id = values.CONNECTION_ID;
    let checkConnectionIDExists = null;

    if (org_con_id === CONNECTION_ID) {
      // connection id is not edited
    } else {
      checkConnectionIDExists = data.find(
        (connection) => connection.CONNECTION_ID === CONNECTION_ID
      );
    }

    if (checkConnectionIDExists) {
      NotificationManager.error("", "Connection ID exists!", 10000);
    } else {
      const payload = [
        {
          _CONNECTION_ID: values._CONNECTION_ID,
          CONNECTION_ID: formData.CONNECTION_ID,
          CONNECTION_TYPE: formData.CONNECTION_TYPE,
          PROJECT_ID: formData.PROJECT_ID,
          PROJECT_OID: formData.PROJECT_OID,
          PROJECT_NAME: formData.PROJECT_NAME,
          SPONSOR_NAME: formData.SPONSOR_NAME,
          BUSINESS_ID: formData.BUSINESS_ID,
          CONNECTION_URL: formData.CONNECTION_URL,
          CONNECTION_PROVIDER: formData.CONNECTION_PROVIDER,
          CONNECTION_DATA: formData.CONNECTION_DATA,
          AUTH_TYPE: formData.AUTH_TYPE,
          AUTH_ID: formData.AUTH_ID,
          AUTH_PIN: formData.AUTH_PIN,
          AUTH_PASSCODE: formData.AUTH_PASSCODE,
          STATE: formData.STATE,
          MAX_ROWS_PER_QUERY: formData.MAX_ROWS_PER_QUERY,
          MAX_QUERIES: formData.MAX_QUERIES,
          PING_SERVICE: formData.PING_SERVICE,
          COMMENTS: formData.COMMENTS,
        },
      ];

      const resourcePath = "integrations/cfg/connections";

      API.UpdateRecord(resourcePath, payload).then((response) => {
        if (response.code === 200) {
          NotificationManager.success("Record Updated", "Connection", 10000);
          fetchEIConenctionsFromAllEnv();
        } else {
          NotificationManager.error(response.message, "Failed!", 10000);
        }
      });
    }
  }

  function handleClone(event) {
    event.preventDefault();
    const CONNECTION_ID = formData.CONNECTION_ID;

    let checkConnectionIDExists = null;

    checkConnectionIDExists = data.find(
      (connection) => connection.CONNECTION_ID === CONNECTION_ID
    );

    if (checkConnectionIDExists) {
      NotificationManager.error("", "Connection ID exists!", 10000);
    } else {
      const payload = [
        {
          CONNECTION_ID: formData.CONNECTION_ID,
          CONNECTION_TYPE: formData.CONNECTION_TYPE,
          PROJECT_ID: formData.PROJECT_ID,
          PROJECT_OID: formData.PROJECT_OID,
          PROJECT_NAME: formData.PROJECT_NAME,
          SPONSOR_NAME: formData.SPONSOR_NAME,
          BUSINESS_ID: formData.BUSINESS_ID,
          CONNECTION_URL: formData.CONNECTION_URL,
          CONNECTION_PROVIDER: formData.CONNECTION_PROVIDER,
          CONNECTION_DATA: formData.CONNECTION_DATA,
          AUTH_TYPE: formData.AUTH_TYPE,
          AUTH_ID: formData.AUTH_ID,
          AUTH_PIN: formData.AUTH_PIN,
          AUTH_PASSCODE: formData.AUTH_PASSCODE,
          STATE: formData.STATE,
          MAX_ROWS_PER_QUERY: formData.MAX_ROWS_PER_QUERY,
          MAX_QUERIES: formData.MAX_QUERIES,
          PING_SERVICE: formData.PING_SERVICE,
          COMMENTS: formData.COMMENTS,
        },
      ];

      const resourcePath = "integrations/cfg/connections";

      API.AddRecord(resourcePath, payload).then((response) => {
        if (response.code === 200) {
          NotificationManager.success(
            "Record added!",
            "Connection Entry",
            10000
          );
          fetchEIConenctionsFromAllEnv();
        } else {
          NotificationManager.error(response.message, "Failed!", 10000);
        }
      });
    }
  }

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  return (
    <Box>
      <Stack spacing={0}>
        <FormField required id="CONNECTION_ID" name="CONNECTION_ID" label="ID" disabled={!editable} value={formData.CONNECTION_ID} onChange={handleChange} />
        <FormField required id="CONNECTION_TYPE" name="CONNECTION_TYPE" label="Type" disabled={!editable} value={formData.CONNECTION_TYPE} onChange={handleChange} />
        <FormField required id="PROJECT_ID" name="PROJECT_ID" label="Project ID" disabled={!editable} value={formData.PROJECT_ID} onChange={handleChange} />
        <FormField required id="PROJECT_OID" name="PROJECT_OID" label="Project OID" disabled={!editable} value={formData.PROJECT_OID} onChange={handleChange} />
        <FormField required id="PROJECT_NAME" name="PROJECT_NAME" label="Project Name" disabled={!editable} value={formData.PROJECT_NAME} onChange={handleChange} />
        <FormField required id="SPONSOR_NAME" name="SPONSOR_NAME" label="Sponsor Name" disabled={!editable} value={formData.SPONSOR_NAME} onChange={handleChange} />
        <FormField required id="BUSINESS_ID" name="BUSINESS_ID" label="Business ID" disabled={!editable} value={formData.BUSINESS_ID} onChange={handleChange} />
        <FormSelectField id="STATE" name="STATE" label="State" disabled={!editable} value={formData.STATE} onChange={handleChange} items={items} />
        <FormField required id="CONNECTION_URL" name="CONNECTION_URL" label="Connection URL" disabled={!editable} value={formData.CONNECTION_URL} onChange={handleChange} />
        <FormField required id="CONNECTION_PROVIDER" name="CONNECTION_PROVIDER" label="Connection Provider" disabled={!editable} value={formData.CONNECTION_PROVIDER} onChange={handleChange} />
        <FormField required id="AUTH_TYPE" name="AUTH_TYPE" label="Auth Type" disabled={!editable} value={formData.AUTH_TYPE} onChange={handleChange} />
        <FormField required id="AUTH_ID" name="AUTH_ID" label="Auth ID" disabled={!editable} value={formData.AUTH_ID} onChange={handleChange} />
        <FormField required id="AUTH_PIN" name="AUTH_PIN" label="Auth PIN" disabled={!editable} value={formData.AUTH_PIN} onChange={handleChange} />
        <FormField required id="AUTH_PASSCODE" name="AUTH_PASSCODE" label="Auth Passcode" disabled={!editable} value={formData.AUTH_PASSCODE} onChange={handleChange} />
        <FormField required id="MAX_ROWS_PER_QUERY" name="MAX_ROWS_PER_QUERY" label="Max rows per query" disabled={!editable} value={formData.MAX_ROWS_PER_QUERY} onChange={handleChange} />
        <FormField required id="MAX_QUERIES" name="MAX_QUERIES" label="Max queries" disabled={!editable} value={formData.MAX_QUERIES} onChange={handleChange} />
        <FormField required id="PING_SERVICE" name="PING_SERVICE" label="Ping Service" disabled={!editable} value={formData.PING_SERVICE} onChange={handleChange} />
        <FormField
          required
          id="CONNECTION_DATA"
          name="CONNECTION_DATA"
          label="Connection Data"
          disabled={!editable}
          value={formData.CONNECTION_DATA}
          onChange={handleChange}
          multiline
          rows={conDataFieldRows}
        />
      </Stack>

      <FormActions>
        <Button variant="outlined" disabled={editable} onClick={onEditClick}>
          Edit
        </Button>
        <Button variant="contained" color="primary" disabled={!editable} onClick={handleSubmit}>
          Save
        </Button>
        <Button variant="outlined" color="secondary" disabled={!editable} onClick={handleClone}>
          Clone
        </Button>
        <Button variant="text" color="inherit" onClick={handleDetailClose}>
          Close
        </Button>
      </FormActions>
    </Box>
  );
};

export default ViewEditConnection;
function calculateCmdTextLines(values) {
  const conData = values.CONNECTION_DATA;
  let conDataFieldRows = 0;
  if (conData !== null && conData !== "") {
    conDataFieldRows = parseInt(conData.length / 80);
  }

  const lines = (conData.match(/\n/g) || "").length + 1;

  conDataFieldRows = parseInt(conDataFieldRows);

  if (lines > conDataFieldRows) {
    conDataFieldRows = lines;
  }
  return conDataFieldRows;
}
